// src/services/auth/accesService.js
// Accès à la plateforme d'un formateur ou d'un apprenant (backend : personnes/acces.py).
import api from '../api';

/**
 * Crée l'accès, ou réinitialise son mot de passe s'il existe déjà.
 * Réponse : { acces, identifiant, mot_de_passe_provisoire, cree }.
 * `base` : 'apprenants' | 'formateurs'.
 */
export const creerOuReinitialiserAcces = async (base, id) => {
  const res = await api.post(`${base}/${id}/acces/`);
  return res.data;
};

/** Désactive le compte (la fiche garde son lien ; réactivable). */
export const desactiverAcces = async (base, id) => {
  const res = await api.delete(`${base}/${id}/acces/`);
  return res.data;
};
